import { createApp } from 'vue'
import SingleMainComponent from './components/single/SingleMainComponent.vue'
// import FloorPlanLoopComponent from './components/FloorPlanLoopComponent.vue'
import directives from './directives'

// Function to initialize Vue apps
function initializeVueApps() {
    const af3ShortcodesApps = document.querySelectorAll('.af3-vue-app-shortcode');
    af3ShortcodesApps.forEach((af3ShortcodesApp) => {
        // Check if the app is already initialized to avoid re-initializing
        if (!af3ShortcodesApp.__vueApp) {
            const app = createApp({});
            
            // Use directives
            app.use(directives);
            
            // List of components to register
            const components = {
                SingleMainComponent, 
            };

            // Register components
            Object.entries(components).forEach(([name, component]) => {
                app.component(name, component);
            });

            // Mount the Vue app and store a reference to avoid re-mounting
            af3ShortcodesApp.__vueApp = app.mount(af3ShortcodesApp);
        }
    });
}



// Call this function on window load
window.addEventListener('load', initializeVueApps);